import React from 'react';
import { Box, Text } from 'grommet';

/**
 * @deprecated Use <Button primary .../> instead
 */
const Primary = (props) => {
  return (
    <Box
      align="center"
      justify="center"
      background={props.background ? props.background : 'accent'}
      round={props.border ? props.border : '4px'}
      border={{ color: 'accent', size: '2px' }}
      pad={{ horizontal: 'medium', vertical: 'xsmall' }}
      focusIndicator={props.focusIndicator ? props.focusIndicator : true}
      flex={false}
      height={{ min: '36px' }}
      {...props}
    >
      <Text color={props.color ? props.color : 'white'} weight={props.weight ? props.weight : 700}>
        {props.label || props.children}
      </Text>
    </Box>
  );
};

export default Primary;
